import {Directive, ElementRef, Renderer2} from '@angular/core';

@Directive({
  selector: 'a[openInNewTab]'
})
export class OpenInNewTabDirective {

  constructor (private _elRef: ElementRef, private _renderer: Renderer2) { }

  ngOnInit() {
    this._renderer.setAttribute(this._elRef.nativeElement, 'target', '_blank');
  }


}
